(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.telsellProductListLoadMoreInitialized) return;
    window.telsellProductListLoadMoreInitialized = true;

    document.addEventListener('click', async (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('[data-product-list-load-more-button]');
      if (!button) return;
      if (button.getAttribute('aria-busy') === 'true') return;

      const wrapper = button.closest('[data-product-list-load-more]');
      const section = button.closest('.section-resource-list');
      if (!wrapper || !section) return;

      const sectionId = section.dataset.productListSectionId;
      const nextPage = Number(wrapper.dataset.nextPage || 0);
      if (!sectionId || !nextPage) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('page', String(nextPage));
        url.hash = '';

        const response = await fetch(url.toString(), {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          throw new Error(`Product list page ${nextPage} failed with ${response.status}`);
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = doc.querySelector('[data-product-list-section-id]');
        const currentGrid = section.querySelector('[data-testid="resource-list-grid"]');
        const nextItems = Array.from(nextSection?.querySelectorAll('[data-product-list-item]') || []);

        if (!currentGrid || nextItems.length === 0) {
          throw new Error(`Product list page ${nextPage} returned no products`);
        }

        currentGrid.append(...nextItems);

        const nextWrapper = nextSection?.querySelector('[data-product-list-load-more]');
        if (nextWrapper instanceof HTMLElement && nextWrapper.dataset.nextPage) {
          wrapper.dataset.nextPage = nextWrapper.dataset.nextPage;
          wrapper.dataset.totalPages = nextWrapper.dataset.totalPages || wrapper.dataset.totalPages || '';
          button.disabled = false;
          button.removeAttribute('aria-busy');
        } else {
          wrapper.remove();
        }
      } catch (error) {
        console.error(error);
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
